import { createFileRoute } from '@tanstack/react-router';
import { ComingSoon } from '@/features/placeholder/ComingSoon.tsx';

// Placeholder until this area is ported — see docs/features/*-revenue.md.
export const Route = createFileRoute('/_app/revenue')({
  component: RevenuePage,
});

function RevenuePage() {
  return <ComingSoon slug="revenue" />;
}
